export default __webpack_public_path__ + "static/media/404.68f010bc.png";